import { CUSTOMER_TYPE } from "../../../../../../constants";
import { ICartItem } from "../../../../../../models";
import { CheckoutSubscription, CustomerExistingSubscription } from "../../../../../../models/state";
import { isBroadbandCode, isZeroPlaySubscription } from "../../../../../../shared/subscriptionCodeUtils";

export const getHeading = (
    subscription: CheckoutSubscription,
    draftSubscriptions: ICartItem[],
    existingSubscriptionForChange?: CustomerExistingSubscription,
) => {
    const isDraft = draftSubscriptions.some((draft) => draft.bundleId === subscription.id);
    const phoneNumber = subscription?.phoneNumber?.selectedPhoneNumber;
    const isExisting = subscription?.phoneNumber?.check?.type === CUSTOMER_TYPE.EXISTING;
    const isMbbSubscription = isBroadbandCode(subscription.code);
    const isExistingSubscription =
        !!existingSubscriptionForChange && subscription.id === existingSubscriptionForChange.bundleId;
    const existingSubscriptionScope = existingSubscriptionForChange?.changeScope;

    if (isMbbSubscription) {
        return `Mobilt bredbånd - ${subscription.name}`;
    }

    if (isZeroPlaySubscription(subscription.code)) {
        return subscription.name || "Tjenesteabonnement";
    }

    if ((isExistingSubscription || isExisting) && phoneNumber) {
        if (existingSubscriptionScope === "sim") {
            return `Endring på SIM-kort${phoneNumber ? ` - ${phoneNumber}` : ""}`;
        }

        if (existingSubscriptionScope === "productUser") {
            return `Endring på bruker${phoneNumber ? ` - ${phoneNumber}` : ""}`;
        }

        return `Endring av mobilabonnement${phoneNumber ? ` - ${phoneNumber}` : ""}`;
    }

    if (isDraft) {
        return subscription.name || "Mobilabonnement";
    }

    const productUserName = [subscription.productUser?.firstName, subscription.productUser?.lastName]
        .filter(Boolean)
        .join(" ");
    const phoneNumberSuffix = phoneNumber ? ` - ${phoneNumber}` : "";

    return `${productUserName}${phoneNumberSuffix}`;
};
